(function () {
    'use strict';

    var ACTIVE = 'active';
    var CLASS_CHANGE = 'classChange';
    var SELECTIZE_FILTER_MODAL = '.selectize-filter-modal';

    angular
        .module('sodCommon')
        .directive('sodSelectizeFilter', sodSelectizeFilter);

    function sodSelectizeFilter($document) {
        return {
            restrict: 'E',
            scope: { config: '=?', activeFilters: '=?', filterType: '=', gridId: '=', options: '=?', autoApply: '=?', applyCallback: '&?', },
            transclude: true,
            templateUrl: 'common/components/sod-selectize-filter',
            controller: sodSelectizeFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: sodSelectizeFilterLink,
        };

        function sodSelectizeFilterLink(scope, elem, attr) {
            $document.on('click', onDocumentClick);

            scope.$on('$destroy', function () {
                $document.off('click', onDocumentClick);
            });

            function onDocumentClick(e) {
                var $selectizeFilterModal = $(elem.find(SELECTIZE_FILTER_MODAL));

                if (!elem[0].contains(e.target)) {
                    $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
                } else {
                    $selectizeFilterModal.addClass(ACTIVE).trigger(CLASS_CHANGE);
                }
            }
        }
    }

    function sodSelectizeFilterCtrl(lodash, $element, $scope, FilterFactory) {
        var vm = this;
        var selectizeInstance = null;
        var filterPath = '';
        var $selectizeFilterModal = null;

        this.$onInit = function() {
            filterPath = [vm.gridId, vm.filterType].join('.');

            vm.apply = apply;
            vm.clear = clear;
            vm.cancel = cancel;
            vm.onSelect = onSelect;
            vm.isSelected = isSelected;
            vm.hasSelectedChanged = hasSelectedChanged;
            vm.selected = FilterFactory.get(filterPath, lodash.get(vm, 'activeFilters', {}));
            setInitialSelected();
            vm.isCurrentlyActive = false;
            vm.config = Object.assign(lodash.get(vm, 'config', {}), {
                autoApply: vm.autoApply,
                selectizeConfig: Object.assign({
                    dropdownParent :  'body',
                    closeAfterSelect: true,
                    placeholder: 'Add a filter',
                    onInitialize: function(selectize) {
                        selectizeInstance = selectize;
                    },
                    onItemAdd: function (value, $item) {
                        selectizeInstance.clear();
                        selectizeInstance.blur();
                        handleAddValue(value);
                    },
                }, lodash.get(vm, 'config', {})),
            });
            vm.options = vm.options || [];
            vm.displayOptions = lodash.take(vm.options, 0);
            $selectizeFilterModal = $($element.find(SELECTIZE_FILTER_MODAL));

            init();
        }




        function init() {
            var filterFactoryListener = $scope.$on([FilterFactory.eventPrefix, filterPath].join('.'), function (e) {
                vm.selected = FilterFactory.get(filterPath);
                handleAddDisplayOptions(vm.selected);
            });
            var filterFactoryHandleDisplayOptionsListener = $scope.$on([FilterFactory.eventPrefix, filterPath, 'addDisplayOptions'].join('.'), function (e, eventData) {
                handleAddDisplayOptions(eventData);
            });
            $scope.$on('destroy', function() {
                filterFactoryListener()
                filterFactoryHandleDisplayOptionsListener();
            });

            $selectizeFilterModal.on('classChange', function (e) {
                e.preventDefault();
                var isActive = $selectizeFilterModal.hasClass(ACTIVE);
                var hasChanged = vm.isCurrentlyActive !== isActive;

                if (hasChanged) {
                    vm.isCurrentlyActive = isActive;
                    if (isActive) {
                        setInitialSelected();
                    }
                }
            });

            handleAddDisplayOptions(FilterFactory.get(filterPath));
        }

        function setInitialSelected() {
            vm.initialSelected = vm.selected;
        }

        function isSelected(value) {
            return lodash.findIndex(vm.selected, function(item) {
                return item == value;
            }) >= 0;
        }

        function hasSelectedChanged() {
            var added = lodash.difference(vm.selected, vm.initialSelected);
            var removed = lodash.difference(vm.initialSelected, vm.selected);
            return vm.isCurrentlyActive && lodash.concat(added, removed).length;
        }

        function onSelect(value, e) {
            e.stopPropagation();
            handleToggleValue(value);
        }

        function handleAddValue(value) {
            vm.selected = lodash.concat(vm.selected, value);
            vm.selected = lodash.uniq(vm.selected);
            vm.selected = FilterFactory.set(filterPath, vm.selected);

            handleAddDisplayOptions(value);
        }

        function handleToggleValue(value) {
            var hasValue = isSelected(value);

            if (hasValue) {
                vm.selected = lodash.filter(vm.selected, function (oSelected) {
                    return oSelected != value;
                });
            } else {
                vm.selected = lodash.concat(vm.selected, value);
            }
            vm.selected = FilterFactory.set(filterPath, vm.selected);
        }

        function handleAddDisplayOptions(value) {
            if (lodash.isArray(value)) {
                return lodash.forEach(value, function (oValue) {
                    handleAddDisplayOptions(oValue);
                });
            }
            var valueKey = 'value';
            var foundSelected = lodash.filter(vm.options, function (option) {
                return lodash.get(option, valueKey, null) == value;
            });

            var combinedDisplayOptions = lodash.concat(vm.displayOptions, foundSelected);
            vm.displayOptions = lodash.uniqBy(combinedDisplayOptions, valueKey);
        }

        function handleApplyCallback() {
            if (vm.applyCallback) {
                vm.applyCallback();
            }
        }

        function apply(e) {
            e.stopPropagation();
            handleApplyCallback();
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }

        function clear(e) {
            e.stopPropagation();
            vm.selected = [];
            vm.selected = FilterFactory.set(filterPath, vm.selected);
            handleApplyCallback();
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }

        function cancel(e) {
            e.stopPropagation();
            vm.selected = vm.initialSelected;
            vm.selected = FilterFactory.set(filterPath, vm.selected);
            $selectizeFilterModal.removeClass(ACTIVE).trigger(CLASS_CHANGE);
        }
    }
})();